// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { InstanceRole } from "./InstanceRole";
import {
  InstanceRoleFromJSON,
  InstanceRoleFromJSONTyped,
  InstanceRoleToJSON,
  InstanceRoleToJSONTyped,
} from "./InstanceRole";

/**
 *
 * @export
 * @interface InstanceUserPut
 */
export interface InstanceUserPut {
  /**
   *
   */
  role: InstanceRole;
}

/**
 * Check if a given object implements the InstanceUserPut interface.
 */
export function instanceOfInstanceUserPut(value: object): value is InstanceUserPut {
  if (!("role" in value) || value["role"] === undefined) return false;
  return true;
}

export function InstanceUserPutFromJSON(json: any): InstanceUserPut {
  return InstanceUserPutFromJSONTyped(json, false);
}

export function InstanceUserPutFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): InstanceUserPut {
  if (json == null) {
    return json;
  }
  return {
    role: InstanceRoleFromJSON(json["role"]),
  };
}

export function InstanceUserPutToJSON(json: any): InstanceUserPut {
  return InstanceUserPutToJSONTyped(json, false);
}

export function InstanceUserPutToJSONTyped(
  value?: InstanceUserPut | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    role: InstanceRoleToJSON(value["role"]),
  };
}
